import { render, staticRenderFns } from "./PreloadModelInstructions.vue?vue&type=template&id=85752e40&scoped=true"
import script from "./PreloadModelInstructions.vue?vue&type=script&lang=ts"
export * from "./PreloadModelInstructions.vue?vue&type=script&lang=ts"
import style0 from "./PreloadModelInstructions.vue?vue&type=style&index=0&id=85752e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85752e40",
  null
  
)

export default component.exports